import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import metricTexts from 'i18n/metric';
import { MetricFormat } from 'constants/scorecards';

interface MetricFormatOption {
  id: MetricFormat;
  name: string;
}

const useMetricFormatOptions = (): MetricFormatOption[] => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => [
      { id: MetricFormat.CURRENCY, name: formatMessage(metricTexts.currency) },
      {
        id: MetricFormat.PERCENTAGE,
        name: formatMessage(metricTexts.percentage),
      },
      { id: MetricFormat.NUMBER, name: formatMessage(metricTexts.number) },
    ],
    [formatMessage],
  );
};

export default useMetricFormatOptions;
